mutation DeleteScoreboard($boardId: ID!) {
  result: StreamToolsDeleteScoreboard(boardId: $boardId) {
    id
    deleted
  }
}
